export default "__VITE_PUBLIC_ASSET__c052beb9__"